/**
 * Dice are a pure function of (seed, index): the same game seed and roll index
 * always give the same result, so any game can be replayed from its seed and
 * move list. Index counts every die rolled (d20 and save die share the stream).
 */
export function draw(seed: number, index: number, n: number): number {
  let x = (seed + Math.imul(index + 1, 0x9e3779b9)) >>> 0;
  x = Math.imul(x ^ (x >>> 16), 0x85ebca6b) >>> 0;
  x = Math.imul(x ^ (x >>> 13), 0xc2b2ae35) >>> 0;
  x = (x ^ (x >>> 16)) >>> 0;
  return x % n;
}
